// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"326":"fbab3058","585":"ffbb8084"}[chunkId] + ".css";
};